import React from 'react'

export default function Form() {
  return (
    <div>
                <div className="card mb-4">
                    <article className="card-body">
                       <h4 className="mb-4">Crear cuenta</h4>
                       <form>
                          <div className="row gx-3">
                             <div className="col mb-4"> <label className="form-label">Nombre</label>
                              <input type="text" className="form-control" placeholder=""/> </div>
                             
                             <div className="col mb-4"> <label className="form-label">Apellido</label>
                              <input type="text" className="form-control" placeholder=""/> </div>
                             
                          </div>
                        
                          <div className="row">
                             <div className="col-auto mb-3"> <label className="form-check">
                                 <input className="form-check-input" type="radio" name="choose_a" /> 
                                 <span className="form-check-label"> CLiente </span> </label> </div>
                             
                             <div className="col-auto mb-3"> <label className="form-check"> 
                             <input className="form-check-input" type="radio" name="choose_a"/>
                                  <span className="form-check-label"> Vendedor </span> </label> </div>
                             
                             <div className="col-auto mb-3"> <label className="form-check"> 
                             <input className="form-check-input" type="radio" name="choose_a" /> 
                             <span className="form-check-label"> Ambos</span> </label> </div>
                             
                          </div>
                        
                          <div className="row gx-3">
                             <div className="col mb-3"> <label className="form-label">Ciudad</label> 
                             <input type="text" className="form-control"/> </div>
                             
                             <div className="col mb-3">
                                <label className="form-label">Pais</label> 
                                <select className="form-select">
                                   <option value="uz">Choose...</option>
                                   <option value="uz">Perú</option>
                                   <option value="ru">Ecuador</option>
                                   <option selected="">United States</option>
                                   <option value="in">Colombia</option>
                                   <option value="af">Venezuela</option>
                                   <option value="af">Bolivian</option>
                                   <option value="af">Argentina</option>
                                </select>
                             </div>
                             
                             <div className="col-12 mb-3"> <label className="form-label">Dirección</label> 
                             <input type="text" className="form-control" placeholder=""/> </div>
                             
                             <div className="col-6 mb-3"> <label className="form-label">Email</label> 
                             <input type="email" className="form-control" placeholder=""/> <small className="form-text">We'll never share your email</small> </div>
                             
                             <div className="col-6 mb-3">
                                <label className="form-label">Celular</label> 
                                <div className="input-group">
                                   <select className="form-select" style={{ maxWidth : "125px"}}>
                                      <option value="us">US +1 </option>
                                      <option value="uz">UZ +998</option>
                                      <option value="ru">RU +72 </option>
                                      <option value="ru">IN +91 </option>
                                      <option value="ru">PK +92 </option>
                                   </select>
                                   <input type="email" className="form-control" placeholder="" /> 
                                </div>
                             </div>
                             
                             <div className="col mb-3"> <label className="form-label">Crear contraseña</label> 
                             <input className="form-control" type="password"/> 
                             </div>
                             
                             <div className="col mb-3"> <label className="form-label">Repetir contraseña</label>
                              <input className="form-control" type="password" /> 
                              </div>
                             
                          </div>
                        
                          <div className="row mt-3 mb-4 align-items-center">
                             <div className="col-auto"> <button className="btn btn-primary" type="button">Registrarse</button> </div>
                             <div className="col"> 
                             <label className="form-check me-auto"> 
                             <input className="form-check-input" type="checkbox" value="" /> 
                             <span className="form-check-label"> He leido los terminos y condiciones </span> </label> </div>
                          </div>
                       </form>
                     
                       <hr />
                       <p className="mb-0">Ya tienes una cuenta? <a >Iniciar aqui</a></p>
                    </article>
                    
                 </div>
    </div>
  )
}
